import LaunchDarkly from 'launchdarkly-node-server-sdk';
import { SERVER_COMMON_TOGGLES, SERVER_TOGGLES } from 'lib/constants';
import { logError } from 'lib/utilities/logger';

// Create an object to store LaunchDarkly client instances
const launchDarklyClients = {
	cruiseSearch: {
		client: null,
		sdkId: 'launchDarklySdkKey',
		constantServer: SERVER_TOGGLES,
		cacheString: 'toggles',
	},
	common: {
		client: null,
		sdkId: 'launchDarklyCommonSdkKey',
		constantServer: SERVER_COMMON_TOGGLES,
		cacheString: 'common_toggles',
	},
};

// Initialize client if not already initialized
const initClient = async (project, secrets) => {
	const config = launchDarklyClients[project];

	if (!config.client) {
		config.client = LaunchDarkly.init(secrets[config.sdkId]);
		await config.client.waitForInitialization();
	}

	return config.client;
};

export async function getServerToggles(locale, config, logId, project, rwdId) {
	let toggles = {};

	try {
		const { brand, envColor, secrets } = config;
		const customParams = {
			brand: brand.code,
			activeColor: envColor,
			countryCode: locale.country,
			country: locale.country,
			market: locale.market,
			rwdId,
		};

		// Initialize or get existing client
		const client = await initClient(project, secrets);
		const { constantServer } = launchDarklyClients[project];

		// Get variations for all toggles
		await Promise.all(
			Object.values(constantServer).map(async (key) => {
				toggles[key] = await client.variation(
					key,
					{
						key: rwdId,
						custom: customParams,
					},
					false,
				);
			}),
		);
	} catch (error) {
		logError('Error in getServerToggles', { error, logId });
	}

	return toggles;
}
